import { debounce } from 'lodash';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';

export const useIsContentScrollable = (open: boolean) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isScrollable, setIsScrollable] = useState(false);

  const checkScrollable = useCallback(
    debounce(() => {
      const element = contentRef.current;
      if (element) {
        setIsScrollable(element.scrollHeight > element.clientHeight);
      }
    }, 300),
    [contentRef.current]
  );

  useLayoutEffect(() => {
    if (!open || !contentRef.current) return;

    const observer = new MutationObserver(() => {
      checkScrollable();
    });

    observer.observe(
      contentRef.current,
      {
        childList: true,
        subtree: true
      }
    );

    const timeoutId = setTimeout(() => {
      checkScrollable();
      window.addEventListener('resize', checkScrollable);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
      window.removeEventListener('resize', checkScrollable);
      checkScrollable.cancel();
    };
  }, [open, checkScrollable, contentRef.current]);

  return { isScrollable, contentRef };
};
